import {
  asset1,
  asset2,
  asset3,
  asset4,
  asset5,
  asset6,
  asset7,
  asset8,
  asset9,
  asset10,
  asset11,
  placeholder,
  asset8Flip,
  asset9Flip,
} from './assets'
import {
  web1 as hweb1,
  web2 as hweb2,
  web3 as hweb3,
  web4 as hweb4,
} from './webs/h'
import {
  web1 as iweb1,
  web2 as iweb2,
  web3 as iweb3,
  web4 as iweb4,
} from './webs/i'
import {
  web1 as mbweb1,
  web2 as mbweb2,
  web3 as mbweb3,
  web4 as mbweb4,
} from './webs/mod-bar'
import {
  web1 as pweb1,
  web2 as pweb2,
  web3 as pweb3,
  web4 as pweb4,
} from './webs/p'
import {
  web1 as spweb1,
  web2 as spweb2,
  web3 as spweb3,
  web4 as spweb4,
} from './webs/single-post'
import { web1, web2, web3 } from './webs/snake-eyes'
import { web1 as tweb1, web2 as tweb2 } from './webs/trap'
import {
  web1 as xweb1,
  web2 as xweb2,
  web3 as xweb3,
  web4 as xweb4,
} from './webs/x'
import {
  web1 as msweb1,
  web2 as msweb2,
  web3 as msweb3,
  web4 as msweb4,
} from './webs/mod-single-post'

const assets = [
  { src: asset1, x: 310.8681, y: 0, itemId: 101 },
  { src: asset2, x: 0, y: 367.3254, itemId: 102 },
  { src: asset3, x: 425.5413, y: 1166.0154 },
  { src: asset4, x: 310.8681, y: 9.8517, itemId: 106 },
  { src: asset5, x: 34.4862, y: 29.4174, itemId: 103, majorLayer: true },
  { src: asset6, x: 22.1649, y: 9.8415, itemId: 109 },
  { src: asset7, x: 192.1668, y: 768.0258, itemId: 108 },
  { src: asset11, x: -95.6301, y: -44.8749, itemId: 107, majorLayer: true },
  {
    src: asset8,
    x: 91,
    y: 570,
    itemId: 103,
    darken: 20,
    blendMode: 'no-blend',
    hasFlippedAsset: true,
    flippedAssetIndex: 0,
  },
  {
    src: asset9,
    x: 956,
    y: 311,
    itemId: 103,
    darken: 20,
    blendMode: 'no-blend',
    hasFlippedAsset: true,
    flippedAssetIndex: 1,
  },
  { src: placeholder, x: 0, y: 0, itemId: 114 },
]

const flippedAssets = [
  {
    src: asset8Flip,
    x: 869,
    y: 500,
    itemId: 103,
    darken: 20,
    blendMode: 'no-blend',
    assetIndex: 8,
  },
  {
    src: asset9Flip,
    x: 13,
    y: 308,
    itemId: 103,
    darken: 20,
    blendMode: 'no-blend',
    assetIndex: 9,
  },
]

const webs = {
  h: [
    { src: hweb1, x: 108.9807, y: 126.0327, itemId: 105, zIndex: 0 },
    {
      src: hweb2,
      x: 110.9853,
      y: 128.9346,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 1,
    },
    { src: hweb3, x: 28.0086, y: 23.2329, itemId: 105, zIndex: 2 },
    {
      src: hweb4,
      x: 50.8287,
      y: 56.8578,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 3,
    },
  ],
  i: [
    { src: iweb1, x: 235.7943, y: 487.6116, itemId: 107, zIndex: 0 },
    { src: iweb2, x: 65.0343, y: 53.2545, itemId: 105, zIndex: 1 },
    {
      src: iweb3,
      x: 99.3333,
      y: 119.4414,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 2,
    },
    // { src: iweb4, x: 79.4043, y: 62.502, itemId: 107, zIndex: 3 },
  ],
  'mod-bar': [
    { src: mbweb1, x: 209.1531, y: 402.2502, itemId: 107, zIndex: 0 },
    { src: mbweb2, x: 79.6716, y: 52.9227, itemId: 105, zIndex: 1 },
    {
      src: mbweb3,
      x: 109.8414,
      y: 114.8685,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 2,
    },
    // { src: mbweb4, x: 85.3896, y: 71.7999, itemId: 107, zIndex: 3 },
  ],
  p: [
    { src: pweb1, x: 68.8998, y: 49.6218, itemId: 105, zIndex: 0 },
    { src: pweb2, x: 120, y: 148, itemId: 105, darken: 10, zIndex: 1 },
    {
      src: pweb3,
      x: 95.3919,
      y: 113.1132,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 2,
    },
    // { src: pweb4, x: 69.6123, y: 55.0173, itemId: 107, zIndex: 3 },
  ],
  'single-post': [
    { src: spweb1, x: 144.6438, y: 159.1512, itemId: 105, zIndex: 0 },
    {
      src: spweb2,
      x: 151.1187,
      y: 162.4386,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 1,
    },
    { src: spweb3, x: 28.0767, y: 23.2896, itemId: 105, zIndex: 2 },
    {
      src: spweb4,
      x: 50.9526,
      y: 56.9967,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 3,
    },
  ],
  'snake-eyes': [
    { src: web1, x: 66.0678, y: 50.8929, itemId: 105, zIndex: 0 },
    {
      src: web2,
      x: 91.9554,
      y: 93.0318,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 1,
    },
    { src: web3, x: 256.1283, y: 497.2278, itemId: 107, zIndex: 2 },
  ],
  trap: [
    { src: tweb1, x: 96.4164, y: 129.7188, itemId: 105, zIndex: 0 },
    {
      src: tweb2,
      x: 49.0599,
      y: 67.9506,
      itemId: 107,
      zIndex: 1,
    },
  ],
  x: [
    { src: xweb1, x: 140.3721, y: 202.6869, itemId: 105, zIndex: 0 },
    {
      src: xweb2,
      x: 143.8038,
      y: 205.6002,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 1,
    },
    { src: xweb3, x: 64.4487, y: 49.9272, itemId: 105, zIndex: 2 },
    {
      src: xweb4,
      x: 90.3039,
      y: 99.6444,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 3,
    },
  ],
  'mod-single-post': [
    { src: msweb1, x: 152.118, y: 208.212, itemId: 105, zIndex: 0 },
    {
      src: msweb2,
      x: 157.2888,
      y: 213.7062,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 1,
    },
    { src: msweb3, x: 66.1563, y: 50.4615, itemId: 105, zIndex: 2 },
    {
      src: msweb4,
      x: 97.6731,
      y: 103.5804,
      itemId: 114,
      blendMode: 'no-blend',
      zIndex: 3,
    },
  ],
}

const data = {
  assets,
  flippedAssets,
  ...webs,
  engraving: [
    {
      src: asset10,
      x: 635.74,
      y: 771.32,
      itemId: 103,
      darken: 20,
      blendMode: 'no-blend',
    },
  ],
}

export default data
